module.exports = __webpack_public_path__ + "img/icon-inizia-guida.01c7bc0c.svg";